import React from 'react'
import { CloseOutlined, RobotOutlined } from '@ant-design/icons'
import { Button, Input } from 'antd'
import style from './ai-chatbot.module.sass'
import { ChatContainer } from './chat-container'
import { ChatBar } from './chat-bar'

import { useLlm } from './useLlm'

const { TextArea } = Input


type AiChatbotProps = {
	onClose: () => void
}

export const AiChatbot: React.FC<AiChatbotProps> = ({ onClose }) => {

	const { send, messages, awaitingResponse } = useLlm()

	return (
		<div className={style.aiChatbotPanel}>
			<div className={style.chatHeader}>
				<div className={style.headerContent}>
					<RobotOutlined className={style.headerIcon} />
					<span className={style.headerTitle}>AI Support</span>
				</div>
				<Button type="text" icon={<CloseOutlined />} onClick={onClose} className={style.closeButton} />
			</div>

			<ChatContainer messages={messages} />
			<ChatBar awaitingResponse={awaitingResponse} send={send} />
		</div>
	)
}
